/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ch_1_DInputs */

const en_cp_ch_1_d = /** @type {(inputs: Cp_Ch_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidence ratio, phases approved on time, justified overrides — read from logs, not slides.`)
};

const id_cp_ch_1_d = /** @type {(inputs: Cp_Ch_1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rasio bukti, fase disetujui tepat waktu, pengecualian beralasan — dibaca dari log, bukan slide.`)
};

/**
* | output |
* | --- |
* | "Evidence ratio, phases approved on time, justified overrides — read from logs, not slides." |
*
* @param {Cp_Ch_1_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ch_1_d = /** @type {((inputs?: Cp_Ch_1_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ch_1_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ch_1_d(inputs)
	return en_cp_ch_1_d(inputs)
});